module.exports = __webpack_public_path__ + "img/21-2.56ef3a1e.png";